import type { DocumentContent, RSSSuggestion } from '../../types';
// eslint-disable-next-line import/no-cycle
import CacheBackedStore from './CacheBackedStore';
// eslint-disable-next-line import/no-cycle
import DocumentContentStore from './DocumentContentStore';

export default {
  documentContent: new DocumentContentStore<DocumentContent, 'id'>({
    name: 'documentContent',
    endpointPath: 'documents/content',
  }),
  knownRssFeeds: new CacheBackedStore<RSSSuggestion, 'domain'>({
    name: 'knownRssFeeds',
    endpointPath: 'known_rss_feeds',

    couldServerReturnFewerItemsThanRequested: true,
    idPropertyName: 'domain',
  }),
  // NOTE: ideally we would also add the documentContentChunks store here, but since it's a FileBackedStore
  // which does not implement the exact same methods as CacheBackedStore, consumers of this `stores` object
  // would break.
  // TtsWordBoundariesStore is also not included here - see ttsWordBoundaryLoading.ts instead.
};
